import {
  UserStatus,
  UserState,
  UserPayload,
  KisaUserStatus
} from './user.model';

const userReducers = {
  changeRegulationsAcceptanceRequired: (state: UserState, status: boolean) => ({
    ...state,
    regulationsAcceptanceRequired: status
  }),
  changeUserStatus: (state: UserState, status: UserStatus) => ({
    ...state,
    userStatus: status
  }),
  changeKisaUserStatus: (state: UserState, status: KisaUserStatus) => ({
    ...state,
    kisaUserStatus: status
  }),
  changeUserData: (state: UserState, userData: UserPayload) => ({
    ...state,
    ...userData.data
  }),
  changeToken: (state: UserState, token: string) => ({
    ...state,
    token
  }),
  clearUserData: (state: UserState) => ({
    ...state,
    id: null,
    clientId: undefined,
    email: '',
    userAccountEmail: undefined,
    firstName: '',
    lastName: '',
    surname: undefined
  }),
  setImpersonation: (state: UserState, impersonation: boolean) => ({
    ...state,
    impersonation
  })
};

export default userReducers;
